import React from "react";
import UserListItem from "../../components/user/UserList/UserListItem";
import {Box} from "@mui/material";
import {useParams} from "react-router";
import {useTitle} from 'react-use';
import { t } from "@lingui/core/macro";

const UserListPage = ()  => {

    useTitle(t`List User`);
    
    const allQueries = useParams()
    const query = Object.fromEntries(
        Object.entries(allQueries).filter(([key]) => key.endsWith("Id"))
    )
    
    return (
        <Box>
            <UserListItem showAdd={true} {...query} />
        </Box>
    )
}

export default UserListPage;
